module.exports = __webpack_public_path__ + "img/Cint400_276.eb34c59c.png";